// src/dashboard/DashboardLayout.jsx

import { Link, Outlet, NavLink } from "react-router-dom";
import { useState } from "react";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div
        className={`transition-all duration-300 bg-orange-500 text-white  shadow-md ${
          sidebarOpen ? "w-64" : "w-22"
        } overflow-hidden`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <Link
            to="/"
            className={`text-white font-semibold px-3 py-2 rounded hover:bg-orange-600 transition duration-300 ${
              sidebarOpen ? "text-base" : "text-xl"
            }`}
          >
            {sidebarOpen ? "🏠 Back To Home" : "🏠"}
          </Link>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-600"
          >
            {sidebarOpen ? "⬅️" : "➡️"}
          </button>
        </div>
       <nav className="mt-4 space-y-2">
        {/* --- NEW JOB OPENINGS LINK --- */}
        <NavLink
          to="/dashboard/job-openings/dashboard"
          className={({ isActive }) =>
            `block px-4 py-2 rounded transition duration-300 ${
              isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
            }`
          }
        >
          {sidebarOpen ? "💼 Job Openings" : "💼"}
        </NavLink>

          <NavLink
            to="/dashboard/staff-dashboard"
            className={({ isActive }) =>
              `block px-4 py-2 rounded transition duration-300 ${
                isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
              }`
            }
          >
            {sidebarOpen ? "📜 Staff Manage" : "📜"}
          </NavLink>

          <NavLink 
            to="/dashboard/project-manage"
            className={({isActive})=>
              `block px-4 py-4 rounded transition duration-300 ${
                isActive ? "bg-orange-700 font-bold":"hover:bg-orange-600"
              }`
            }
          >
            {sidebarOpen ?  "💼 Project Manage" : "💼"}
          </NavLink>
    
  
  <NavLink
    to="/dashboard/bank-account"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "📜 Bank Account" : "📜"}
  </NavLink>
  <NavLink
    to="/dashboard/shiksha-vistar"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "📜 Shiksha-Vistar" : "📜"}
  </NavLink>
  <NavLink
    to="/dashboard/id-card"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "📜 ID-Card Manage " : "📜"}
  </NavLink>

  <NavLink
            to="/dashboard/stationary"
            className={({ isActive }) =>
              `block px-4 py-2 rounded transition duration-300 ${
                isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
              }`
            }
          >
            {sidebarOpen ? "📜 Stationary Manage" : "📜"}
          </NavLink>

           <NavLink
    to="/dashboard/umedwar-list"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "📜 Umedwar List " : "EL"}
  </NavLink>
</nav>

      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <main className="p-4 bg-gray-100 flex-grow">
          {/* This renders nested routes like YatraList  */}
          <Outlet />   
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;